import { useCallback } from "react"
import { useAxiosInstances } from "../../axios-instance"
import { IColunaExtracao, ILayoutExtracao, ILayoutExtracaoTable } from "../../../application/models"

export const useLayoutExtracaoApi = () => {
    const { axiosAuthInstance } = useAxiosInstances()

    const deleteLayoutApi = useCallback(async (data: {
        IdVelesGeoLayoutExtracao: number
    }): Promise<ILayoutExtracao> => {
        try {
            const result = await axiosAuthInstance.delete(`/geo-veles/layout-extracao/${data.IdVelesGeoLayoutExtracao}`)

            return result.data.layoutExtracao
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const findLayoutsByIdUsuarioApi = useCallback(async (data: {
        IdUsuario: number
    }): Promise<ILayoutExtracaoTable[]> => {
        try {
            const result = await axiosAuthInstance.get(`/geo-veles/layout-extracao/usuario/${data.IdUsuario}`)

            return result.data.layoutExtracao
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const createLayoutApi = useCallback(async (data: {
        IdUsuario: number
        Nome: string
        Colunas: IColunaExtracao[]
    }): Promise<ILayoutExtracao> => {
        try {
            const result = await axiosAuthInstance.post('/geo-veles/layout-extracao/', {
                IdUsuario: data.IdUsuario,
                Nome: data.Nome,
                Colunas: data.Colunas
            })

            return result.data.layoutExtracao
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const updateLayoutApi = useCallback(async (data: {
        IdVelesGeoLayoutExtracao: number
        Nome: string
        Colunas: IColunaExtracao[]
    }): Promise<ILayoutExtracao> => {
        try {
            const result = await axiosAuthInstance.put('/geo-veles/layout-extracao/', {
                IdVelesGeoLayoutExtracao: data.IdVelesGeoLayoutExtracao,
                Nome: data.Nome,
                Colunas: data.Colunas
            })

            return result.data.layoutExtracao
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    return {
        deleteLayoutApi,
        findLayoutsByIdUsuarioApi,
        createLayoutApi,
        updateLayoutApi
    }
}